import * as React from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import Typography from "@material-ui/core/Typography";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import createStyles from "@material-ui/core/styles/createStyles";
import { User, Report, Role } from "../../api/classes";
import { Link } from "react-router-dom";
import * as routes from "../../routes";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { Menu, MenuItem } from "@material-ui/core";
import MoreSettings from "../../components/more";
import { render } from "react-dom";
import EditUser from "./edit";
import ApproveDialog from "../../components/dialogs/approveDialog";
import { GlobalState } from "src/store";
import * as actions from "../../store/cases/actions";
import { connect } from "react-redux";
import { DubitoSvc } from "src/api";
import { element } from "prop-types";
import { openSnack } from "src/util/util";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      textAlign: "center"
      //   paddingTop: theme.spacing.unit * 20
    }
  });

type State = {
  open: boolean;
};
const styles1 = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto"
  },
  table: {
    minWidth: 700
  }
});

const rows = [
  {
    id: "id",
    numeric: true,
    disablePadding: false,
    label: "ID"
  },

  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "Name"
  },

  {
    id: "email",
    numeric: false,
    disablePadding: true,
    label: "E- Mail",
    filterable: true
  },

  {
    id: "role_id",
    numeric: false,
    disablePadding: false,
    label: "Role ID"
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status"
  }
];
interface Props {
  classes: any;
  elements: User[];
  roles: Role[];
  fetchUsers: () => void;
}
class UserTable extends React.Component<Props> {
  state = {
    element: undefined,
    editOpen: false,
    deleteOpen: false
  };
  openAddUser = () => {
    this.setState({ deleteOpen: false, editOpen: true, element: undefined });
  };
  openDeleteUser = () => {
    this.setState({ deleteOpen: true, editOpen: false, element: undefined });
  };
  closeDialogs = () => {
    this.setState({ editOpen: false, deleteOpen: false, element: undefined });
  };
  deleteUser = () => {
    DubitoSvc.deleteUser({ user_id: this.state.element.id })
      .then(() => {
        openSnack("Delete succesful!", "success");
        this.props.fetchUsers();
        // this.props
        this.closeDialogs();
      })
      .catch(() => {
        openSnack("Delete failed!", "error");
      });
  };
  renderEditAndDelete() {
    return (
      <>
        <EditUser
          roles={this.props.roles}
          element={this.state.element}
          open={this.state.editOpen}
          onCancel={this.closeDialogs}
          onEdit={() => {
            this.setState({ editOpen: false });
            this.props.fetchUsers();
            // this.props();
          }}
        />
        {this.state.element && (
          <ApproveDialog
            title={this.state.element.title}
            description={
              "Do you really want to delete " +
              this.state.element.name +
              " User?"
            }
            open={this.state.deleteOpen}
            onApprove={this.deleteUser}
          />
        )}
      </>
    );
  }
  getRoleName = role_id => {
    //console.log("role_id", role_id, this.props.roles);
    const c = this.props.roles.find(i => i.id === role_id);
    if (c) {
      return c.name;
    } else {
      return "-";
    }
  };
  changeStatus = rowData => () => {
    DubitoSvc.setUserStatus({
      user_id: rowData.id,
      status: rowData.status === "active" ? "passive" : "active"
    })
      .then(() => {
        openSnack(
          rowData.status === "active"
            ? "Account disabled succesfully!"
            : "Account activated!",
          "success"
        );
        this.props.fetchUsers();
        // this.props
        // this.closeDialogs();
      })
      .catch(() => {
        openSnack("Operation failed!", "error");
      });
  };
  render() {
    const { classes, elements } = this.props;
    return (
      <Paper className={classes.root}>
        {this.renderEditAndDelete()}
        <Toolbar>
          <div className={classes.title}>
            <Typography variant="title" id="tableTitle">
              Users
            </Typography>
          </div>
          <div className={classes.spacer} />
          <div className={classes.actions}>
            <Tooltip title="Add User">
              <IconButton onClick={this.openAddUser} aria-label="Add User">
                <AddIcon />
              </IconButton>
            </Tooltip>
          </div>
        </Toolbar>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Status</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {elements &&
              elements.map((row: User) => {
                return (
                  <TableRow key={row.id}>
                    <TableCell>{row.id}</TableCell>
                    <TableCell>
                      <Link
                        to={"/profile/" + row.id}
                        style={{ textDecoration: "none" }}
                      >
                        {row.name}
                      </Link>
                    </TableCell>
                    <TableCell> {row.email} </TableCell>
                    <TableCell>{this.getRoleName(row.role_id)}</TableCell>
                    <TableCell> {row.status}</TableCell>
                    <TableCell>
                      <MoreSettings
                        options={[
                          {
                            label: "Edit",
                            onClick: () => {
                              this.setState({
                                editOpen: true,
                                deleteOpen: false,
                                element: row
                              });
                            }
                          },
                          {
                            label: "Delete",
                            onClick: () => {
                              this.setState({
                                deleteOpen: true,
                                editOpen: false,
                                element: row
                              });
                            }
                          },
                          {
                            label:
                              row.status === "active"
                                ? "Deactivate"
                                : "Activate",
                            onClick: this.changeStatus(row)
                          }
                        ]}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </Paper>
    );
  }
}
export default connect(
  (state: GlobalState, own: any) => ({}),
  dispatch => ({
    fetchUsers: (): any => dispatch(actions.fetchUsers())
  })
)(withStyles(styles)(UserTable));



// WEBPACK FOOTER //
// ./src/pages/users/table.tsx